import React, { useEffect, useState } from 'react';
import axios from 'axios'

export default function SiteSurvey({ siteSurvey, setSiteSurvey, isOpensite, setIsOpensite, selectpreoderid, apiMaterials }) {
    const [shippingAddress, setShippingAddress] = useState(null)
    const [shippingAddresses, setShippingAddresses] = useState([])
    const [customerid, setcustomerid] = useState()
    const [isLoading, setIsLoading] = useState(false);




    useEffect(() => {
        axios({
            url: `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/${selectpreoderid}`,
            method: "GET",
            headers: {
                Authorization: `Bearer ${localStorage.getItem("authToken")}`,
            },
        })
            .then((res) => {
                const data = res.data;

                // Combine shipping address into a single field
                const shippingAddress = `${data.customer_shipping_address.address_line1}, ${data.customer_shipping_address.address_line2}, ${data.customer_shipping_address.city}, ${data.customer_shipping_address.state}, ${data.customer_shipping_address.country}, ${data.customer_shipping_address.pincode}`;
                setcustomerid(data.customer.customer_id)

                // setShippingAddress(shippingAddress)
            }).catch((err) => {
                console.error(err)
            })

    }, [selectpreoderid])
    useEffect(() => {
        if (customerid) {
            const fetchData = async () => {
                setIsLoading(true); // Start loading

                try {
                    // Fetch shipping addresses
                    const addressResponse = await axios.get(
                        `${process.env.REACT_APP_MYBACKEND_PI}/api/customer/customershipping/address/${customerid}`
                    );
                    setShippingAddresses(addressResponse.data || []);
                    // console.log(addressResponse.data, "cheat");

                    // Fetch billing date
                    const billingResponse = await axios.get(
                        `${process.env.REACT_APP_MYBACKEND_PI}/api/customer/getcustomer/details/${customerid}`
                    );
                    // console.log(billingResponse.data.data, "checkdate");

                } catch (err) {
                    console.error("Error during API calls:", err);
                    // Reset data in case of failure
                    setShippingAddresses([]);
                } finally {
                    setIsLoading(false); // Stop loading in all cases (success or error)
                }
            };

            fetchData();
        }
    }, [customerid]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setSiteSurvey(prevData => ({
            ...prevData,
            [name]: value
        }));
    };
    const handleCloseModal = () => {
        setIsOpensite(!isOpensite)
    }

    const handleAddressChange = (value) => {
        setShippingAddress(value);
    };





    const uploadSitedetails = async (site_details) => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_MYBACKEND_PI}/api/google-sheets/site-visit`,
                { site_details },
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("authToken")}`, // Add token here
                    },
                }
            );
            // console.log('Data successfully uploaded to Google Sheets:', response.data);
        } catch (error) {
            console.error('Error uploading data to Google Sheets:', error.response ? error.response.data : error.message);
        }
    };


    const updateSiteSurvey = async () => {
        // List of required fields with their labels
        const requiredFields = [
            { key: "DateofSiteSurvey", label: "Date of Site Survey" },
            { key: "TimeofSiteSurvey", label: "Time of Site Survey" },
        ];

        // Find missing fields
        const missingFields = requiredFields.filter(field => !siteSurvey[field.key]);

        if (missingFields.length > 0) {
            const missingFieldNames = missingFields.map(field => field.label).join(", ");
            alert(`⚠️ Please fill out the following required fields before submitting the request: ${missingFieldNames}. 😟`);
            return;
        }

        try {
            // Update site survey in the backend
            const response = await axios.patch(
                `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/updatesitevisit/${selectpreoderid}`,
                siteSurvey
            );

            alert("🎉✨ You have successfully raised a site visit request! ✨🎉");

            // Fetch updated order details
            const orderResponse = await axios({
                url: `${process.env.REACT_APP_MYBACKEND_PI}/api/preOrder/${selectpreoderid}`,
                method: "GET",
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                },
            });

            const data = orderResponse.data;

            // Combine shipping address into a single field
            const shippingAddress = `${data.customer_shipping_address.address_line1}, ${data.customer_shipping_address.address_line2}, ${data.customer_shipping_address.city}, ${data.customer_shipping_address.state}, ${data.customer_shipping_address.country}, ${data.customer_shipping_address.pincode}`;
            setShippingAddress(shippingAddress);

            const materialQuantities = apiMaterials.reduce((acc, material) => {
                acc[material.material_code] = 0;
                return acc;
            }, {});
            // Map material quantities
            // const materialQuantities = {
            //     copper_piping_p: 0,
            //     copper_piping_cassette_p: 0,
            //     core_cable_4_p: 0,
            //     l_stand_p: 0,
            //     cross_stand_p: 0,
            //     rubber_stand_p: 0,
            //     dismantling_charges_p: 0,
            //     uninstall_cassette_charges: 0,
            //     jumbo_stand: 0,
            //     add_on_split: 0,
            //     add_on_cassette: 0,
            //     relocation_split: 0,
            //     relocation_cassette: 0,
            // };

            data.materialsdetails.forEach((material) => {
                if (materialQuantities.hasOwnProperty(material.material_name)) {
                    materialQuantities[material.material_name] += material.quantity || 0;
                }
            });

            // Format AC details and calculate totals
            const acDetails = data.AcDetails.reduce((acc, ac) => {
                const acKey = `${ac.ac_type}Ac`; // e.g., 'SplitAc', 'CassetteAc'
                if (!acc[acKey]) {
                    acc[acKey] = [];
                }
                acc[acKey].push({ model: ac.model, quantity: ac.quantity });
                return acc;
            }, {});

            // Initialize AC quantities
            let split1Ton = 0;
            let split2Ton = 0;
            let split1_5Ton = 0;
            let cassette2Ton = 0;
            let cassette3Ton = 0;

            // Process the `SplitAc` array if available
            if (acDetails.SplitAc) {
                acDetails.SplitAc.forEach((item) => {
                    switch (item.model) {
                        case "S10":
                            split1Ton += item.quantity;
                            break;
                        case "S20":
                            split2Ton += item.quantity;
                            break;
                        case "S15":
                            split1_5Ton += item.quantity;
                            break;
                        default:
                            console.warn(`Unhandled Split AC model: ${item.model}`);
                    }
                });
            }

            // Process the `CassetteAc` array if available
            if (acDetails.CassetteAc) {
                acDetails.CassetteAc.forEach((item) => {
                    switch (item.model) {
                        case "C20":
                            cassette2Ton += item.quantity;
                            break;
                        case "C30":
                            cassette3Ton += item.quantity;
                            break;
                        default:
                            console.warn(`Unhandled Cassette AC model: ${item.model}`);
                    }
                });
            }

            // Create the `site_details` object
            const site_details = {
                customerName: data.customer.name,
                customer_id: data.customer.customer_id,
                customermobile: data.customer.mobile,
                preOrdertimestamp: data.preOrdertimestamp,
                contactPerson: data.customer_shipping_address.contactPerson,
                contactNumber: data.customer_shipping_address.contactNumber,
                DateofSiteSurvey: data.DateofSiteSurvey,
                TimeofSiteSurvey: data.TimeofSiteSurvey,
                siteSurveycomment: data.siteSurveycomment,
                shippingAddress,
                pincode: data.customer_shipping_address.pincode,
                split1Ton,
                split2Ton,
                split1_5Ton,
                cassette2Ton,
                cassette3Ton,
                ...materialQuantities, // Include all material quantities dynamically
            };

            // Upload details to Google Sheets
            uploadSitedetails(site_details);

            // Close the modal
            setIsOpensite(!isOpensite);
        } catch (error) {
            console.error("Error updating site survey:", error.response?.data || error.message);
            alert("⚠️ Oops! Failed to raise the site visit request. Please try again. 😟");
        }
    };

    function generateTimeSlots(selectedDate) {
        const slots = [
            { start: 9, end: 12 },
            { start: 12, end: 15 },
            { start: 15, end: 18 },
            { start: 18, end: 21 }
        ];

        const now = new Date();
        const todayDate = now.toISOString().split('T')[0];
        const currentHour = now.getHours();

        if (!selectedDate) return [];

        const selectedDay = new Date(selectedDate).toISOString().split('T')[0];

        // If today, filter out past slots
        const availableSlots = slots.filter(slot => {
            return selectedDay !== todayDate || slot.start > currentHour;
        });

        return availableSlots.map(slot => `${formatTime(slot.start)} - ${formatTime(slot.end)}`);
    }

    function formatTime(hour) {
        const ampm = hour >= 12 ? "PM" : "AM";
        const formattedHour = hour % 12 === 0 ? 12 : hour % 12;
        return `${formattedHour}:00 ${ampm}`;
    }






    return (
        <>
            {isOpensite && (
                <div
                    className="fixed inset-0 bg-black bg-opacity-50 z-50 flex justify-center items-center"
                    onClick={handleCloseModal}
                >
                    <div
                        className="bg-white shadow-md rounded-xl border-2 p-4 max-w-lg w-full relative"
                        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
                    >
                        <button
                            className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
                            onClick={handleCloseModal}
                        >
                            ✖️
                        </button>

                        <h1 className="font-medium text-base mb-4">Site Survey Details</h1>

                        <div className="grid grid-cols-2 gap-4">

                            <div>
                                <label htmlFor="DateofSiteSurvey" className="block text-sm font-medium mb-1">
                                    Requested Site Visit Date
                                </label>
                                <input
                                    type="date"
                                    id="DateofSiteSurvey"
                                    name="DateofSiteSurvey"
                                    className="w-full border border-gray-300 rounded px-2 py-1 text-sm"
                                    value={siteSurvey.DateofSiteSurvey}

                                    onChange={handleInputChange}

                                    min={new Date().toISOString().split('T')[0]} // Restricts to today or future dates
                                />
                            </div>
                            <div>
                                <label htmlFor="TimeofSiteSurvey" className="block text-sm font-medium mb-1">
                                    Requested Site Visit Time
                                </label>
                                <select
                                    id="TimeofSiteSurvey"
                                    name="TimeofSiteSurvey"
                                    className="w-full border border-gray-300 rounded px-2 py-1 text-sm"
                                    value={siteSurvey.TimeofSiteSurvey || ""}
                                    onChange={handleInputChange}
                                    disabled={!siteSurvey.DateofSiteSurvey}
                                >
                                    <option value="" disabled>
                                        -- Select a time slot --
                                    </option>
                                    {generateTimeSlots(siteSurvey.DateofSiteSurvey).map((slot, index) => (
                                        <option key={index} value={slot}>
                                            {slot}
                                        </option>
                                    ))}
                                </select>
                            </div>

                        </div>

                        <div className="mt-4">
                            <label htmlFor='siteAddress' className="block text-sm font-medium mb-1">Site Address:</label>
                            <select
                                value={shippingAddress}
                                name="siteAddress"
                                onChange={(e) => handleAddressChange(e.target.value)}
                                className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary resize-none appearance-none"
                            >
                                <option value="" disabled>
                                    Select a site address...
                                </option>
                                {Array.isArray(shippingAddresses) && shippingAddresses.length > 0 ? (
                                    shippingAddresses.map((address, index) => (
                                        <option
                                            key={index}
                                            value={address._id}
                                            style={{
                                                whiteSpace: "pre-wrap"
                                            }}
                                        >
                                            {`${address.line1}\n${address.pincode}\n${address.city}\n${address.state}`}
                                        </option>
                                    ))
                                ) : (
                                    <option value="" disabled>
                                        No addresses available
                                    </option>
                                )}
                            </select>
                        </div>

                        {/* Comment Section */}
                        <div className="mt-4">
                            <label className="block text-sm font-medium mb-1">Write a Comment:</label>
                            <textarea
                                value={siteSurvey.siteSurveycomment || ""}
                                onChange={handleInputChange}
                                name="siteSurveycomment"
                                placeholder="Add your comments here..."
                                className="w-full border border-gray-300 rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-primary"
                            ></textarea>
                        </div>

                        {/* Submit Button */}
                        <button
                            onClick={updateSiteSurvey}
                            className="w-full bg-primary text-white mt-4 rounded py-2 text-sm"
                        >
                            Request Site Visit
                        </button>
                    </div>
                </div>
            )}

        </>

    );
}
